export const entityParty = {
  EntityParty: {
    keyFields: ["id", "roles"],
  },
}
